import { render, staticRenderFns } from "./studyInfo.vue?vue&type=template&id=5b67a326&scoped=true&"
import script from "./studyInfo.vue?vue&type=script&lang=js&"
export * from "./studyInfo.vue?vue&type=script&lang=js&"
import style0 from "./studyInfo.vue?vue&type=style&index=0&id=5b67a326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b67a326",
  null
  
)

export default component.exports